module.exports = __webpack_public_path__ + "img/pic29.60f89a55.png";